import { memo } from "react"
import { TripSearchResultRelatedNotificationData } from "@cruisen/contract"
import { datesFormats, formatDate } from "@cruisen/react-shared"
import { ErrorHandledImage } from "../../atoms/ErrorHandledImage"
import styles from "./styles.module.scss"
import { handleNotificationAction } from "../../../services/notifications-navigation.ts"

const formatLikedCruiseDate = (startDate: string, endDate: string) => {
  const isValidStartDate = !isNaN(Date.parse(startDate))
  const isValidEndDate = !isNaN(Date.parse(endDate))

  if (!isValidStartDate || !isValidEndDate) {
    return ""
  }

  return `${formatDate(startDate, datesFormats.monthWithDay)} - ${formatDate(
    endDate,
    datesFormats.monthWithDay,
  )}`
}

const NavigatorCruiseCardComponent = ({
  data,
  testID,
}: {
  data: TripSearchResultRelatedNotificationData
  testID: string
}) => {
  return (
    <div className={styles.wrapper}>
      <button
        className={styles.pressable}
        data-testid={testID}
        onClick={() => handleNotificationAction({ id: "openTripSearchResult" }, data)}
      >
        <ErrorHandledImage
          uri={data.cruiseSailingHeroImage}
          enableCaching
          className={styles.cruiseImage}
          errorMessage="Cruise image unavailable"
        />
        <div className={styles.row}>
          <div className={styles.center}>
            <ErrorHandledImage uri={data.cruiseSailingLineLogo} className={styles.logoImage} />
          </div>
          <div className={styles.column}>
            <p className={styles.name}>{data.cruiseSailingName}</p>
            <p className={styles.date}>
              {formatLikedCruiseDate(data.cruiseSailingStartDate, data.cruiseSailingEndDate)}
            </p>
            {(data as { cabinNo?: number })?.cabinNo && (
              <p className={styles.cabin}>Cabin #{(data as { cabinNo?: number })?.cabinNo}</p>
            )}
          </div>
        </div>
      </button>
    </div>
  )
}

function areEqual(
  prevProps: { data: TripSearchResultRelatedNotificationData },
  nextProps: { data: TripSearchResultRelatedNotificationData },
) {
  return prevProps.data.tripSearchResultId === nextProps.data.tripSearchResultId
}

export const NavigatorCruiseCard = memo(NavigatorCruiseCardComponent, areEqual)
